import { useEffect, useState } from 'react'
import { apiGet } from '../api'

const CATEGORY_LABELS = {
    Egg: 'Egg',
    Broiler: 'Broiler',
    hatchEgg: 'Hatch Egg',
    broilerChicks: 'Broiler Chick',
    layerChicks: 'Layer Chick',
}

// Shape a backend price row for the hero card and ticker.
const toRate = (row) => ({
    city: row.city,
    state: row.state,
    category: row.productCategory,
    type: CATEGORY_LABELS[row.productCategory] || row.productCategory,
    price: `₹${Number(row.price).toLocaleString('en-IN')}`,
    change: `${Math.abs(Number(row.percentageChange) || 0)}%`,
    up: row.changeStatus !== 'Decrease',
    flat: row.changeStatus === 'noChange',
    updated: row.updateDate ? new Date(row.updateDate) : null,
})

const useApiData = (path, transform) => {
    const [state, setState] = useState({ data: null, error: false })
    useEffect(() => {
        let cancelled = false
        apiGet(path)
            .then((body) => { if (!cancelled) setState({ data: transform(body.data), error: false }) })
            .catch(() => { if (!cancelled) setState({ data: null, error: true }) })
        return () => { cancelled = true }
    }, [path, transform])
    return state
}

const toRates = (rows) => (Array.isArray(rows) ? rows.map(toRate) : [])
const toStats = (stats) => stats || null

// { data: rate[] | null, error }
export const useLandingRates = () => useApiData('/user/landing/rates', toRates)

// { data: { farmers, states, farms, vets } | null, error }
export const useLandingStats = () => useApiData('/user/landing/stats', toStats)
